export default Object.freeze({
  SINGER_TAPS_ENABLED: 'SINGER_TAPS_ENABLED',
  NATIVE_TAPS_ENABLED: 'NATIVE_TAPS_ENABLED',
  GENERIC_TAPS_ENABLED: 'GENERIC_TAPS_ENABLED',
  RESYNC_TOOL: 'RESYNC_TOOL',
  DATA_OBSERVABILITY_ENABLED: 'DATA_OBSERVABILITY_ENABLED',
  SANDBOX_TESTING: 'SANDBOX_TESTING',
  ETL_SCRIPT: 'ETL_SCRIPT',
  S3_FILE_FORMAT_PICKER: 'S3_FILE_FORMAT_PICKER',
  NEW_OBSERVABILITY_METRICS: 'NEW_OBSERVABILITY_METRICS',
  SNOWFLAKE_KEY_PAIR_AUTH: 'SNOWFLAKE_KEY_PAIR_AUTH',
});
